<template>
  <div class="evaluating">
    <!-- <bannerof
      v-if="navlist !== null && navlist.length > 0"
      style="color: #ffffff"
      :Imgsrc="childrendata[0].bannerUrl"
    ></bannerof> -->
    <secondary-banner title="学业预警帮扶"></secondary-banner>
    <div class="secondary_page_bg">
      <div class="inner">
        <el-row
          :gutter="20"
          type="flex"
          class="warning_wrap"
          v-if="muluList.length > 0 || loading"
          v-loading="loading"
        >
          <el-col :span="8">
            <div class="nulu_list">
              <div class="title">目录</div>
              <div
                :class="['mulu_item', filterIndex == index ? 'nulu_active' : '']"
                v-for="(item, index) in muluList"
                :key="index"
                @click="handleearlyWarningDetails(item, index)"
              >
                <div class="title">
                  <span>{{ parseDate(item.createTime, "{y}/{m}/{d}") }}</span>
                  <span class="middle ellipsis">{{ item.courseName }}</span>
                  <span
                    >完成进度{{
                      item.traineeList.length > 0 ? item.traineeList[0].totalStudy : "0"
                    }}%</span
                  >
                </div>
                <p class="jianjie ellipsis">{{ item.teacherComments }}</p>
                <img
                  v-show="filterIndex == index"
                  style="width: 30px"
                  src="~@/assets/images/back.png"
                  alt=""
                />
              </div>
            </div>
          </el-col>
          <el-col :span="16">
            <div
              class="mulu_details"
              v-if="bangfuDetails || detailsLoading"
              v-loading="detailsLoading"
            >
              <template v-if="bangfuDetails">
                <div class="title">预警详情</div>
                <div class="bangfusub_title">
                  <span>{{ parseDate(bangfuDetails.createTime, "{y}/{m}/{d}") }}</span>
                  <span class="middle">{{ bangfuDetails.courseName }}</span>
                  <span
                    >完成进度{{
                      bangfuDetails.traineeStudyVO
                        ? bangfuDetails.traineeStudyVO.totalStudy
                        : "0"
                    }}%</span
                  >
                </div>
                <div class="warning_box">
                  <span>预警条件：</span>
                  <span
                    style="color: #f78919; border-bottom: 1px solid #999"
                    v-for="(item, index) in bangfuDetails.conditionIds"
                    :key="index"
                    >{{ item.label }}</span
                  >
                </div>
                <p class="pingyv">
                  <span>教师评价：</span>
                  <span style="color: #f78919; border-bottom: 1px solid #999">{{
                    bangfuDetails.teacherComments
                  }}</span>
                </p>
                <div class="course_box">
                  <p class="hot_course">推荐学习：</p>
                  <el-row :gutter="10">
                    <el-col
                      :span="8"
                      v-for="(item, index) in bangfuDetails.courseList"
                      :key="index"
                    >
                      <MyCourseItem
                        :course="item"
                        @setCoursePath="handleCoursePath"
                      ></MyCourseItem>
                    </el-col>
                  </el-row>
                </div>
              </template>
            </div>
          </el-col>
        </el-row>
        <el-empty
          description="你真的很优秀"
          v-if="muluList.length == 0 && !loading"
        ></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import bannerof from "@/components/bannerof";
import SecondaryBanner from "@/components/SecondaryBanner";
import MyCourseItem from "@/components/MyCourseItem";
import { parseDate } from "@/utils";
import {
  getEarlyWarningByEarlyWarningIdAndTraineeId,
  traineeEarlyWarningDirectory,
} from "@/api/user";
export default {
  name: "earlyWarning",
  data() {
    return {
      navId: null,
      childtype: null,
      navlist: null,
      childrendata: null,
      bannerData: {
        title: "",
        subtit: "",
      },
      muluList: [],
      filterIndex: 0,
      bangfuDetails: null,
      loading: true,
      detailsLoading: true,
    };
  },
  components: {
    bannerof,
    SecondaryBanner,
    MyCourseItem,
  },
  watch: {
    "$store.state.user.navbarList": {
      deep: true, //深度监听
      handler(newValue, oldValue) {
        if (newValue.length > 0) {
          this.$nextTick(() => {
            this.navforEcher();
          });
        }
      },
    },
    "$route.query": {
      deep: true, //深度监听
      handler(newValue, oldValue) {
        if (!newValue.childtype) {
          this.childtype = null;
        } else {
          this.childtype = newValue.childtype;
        }

        this.$nextTick(() => {
          this.navforEcher();
        });
      },
    },
  },
  created() {
    this.navId = this.$route.query.navId;
    if (this.$route.query.childtype) {
      this.childtype = this.$route.query.childtype;
    } else {
      this.childtype = null;
    }
    this.traineeEarlyWarningDirectory();
  },
  mounted() {
    this.$nextTick(() => {
      this.navforEcher();
    });
  },
  methods: {
    // 注册时间格式化方法
    parseDate,
    navforEcher() {
      var navlistall = JSON.parse(JSON.stringify(this.$store.state.user.navbarList));
      //筛选出来当前tab栏
      this.navlist = navlistall.filter((el) => {
        return this.navId == el.id;
      });
      if (navlistall.length > 0) {
        //给tab底部高亮
        this.$store.commit("user/SET_TABINDEX", this.childtype);
        if (this.childtype !== null) {
          this.childrendata = this.navlist[0].children.filter((el) => {
            return this.childtype == el.id;
          });
        }
      }
    },
    // 帮扶目录
    traineeEarlyWarningDirectory() {
      this.loading = true;
      traineeEarlyWarningDirectory({ traineeId: this.$store.getters.userId })
        .then((res) => {
          if (res.data.length > 0) {
            this.muluList = res.data;
            this.getEarlyWarningByEarlyWarningIdAndTraineeId({
              traineeId: this.$store.getters.userId,
              earlyWarningId: this.muluList[0].id,
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 帮扶详情
    getEarlyWarningByEarlyWarningIdAndTraineeId(data) {
      this.detailsLoading = true;
      getEarlyWarningByEarlyWarningIdAndTraineeId(data)
        .then((res) => {
          const courseCompletionRate = res.data.traineeStudyVO.courseCompletionRate.map(
            (v) => ({
              ...v,
              studyProgress: v.completionRate,
            })
          );
          res.data.courseList = res.data.materials.map((v) => ({
            ...v,
            ...courseCompletionRate.find((m) => m.courseId == v.id),
          }));
          this.bangfuDetails = res.data;
          this.detailsLoading = false;
        })
        .catch(() => {
          this.detailsLoading = false;
        });
    },
    // 获取帮扶详情
    handleearlyWarningDetails(item, index) {
      this.filterIndex = index;
      this.getEarlyWarningByEarlyWarningIdAndTraineeId({
        traineeId: this.$store.getters.userId,
        earlyWarningId: item.id,
      });
    },
    handleCoursePath(item) {
      const rourl = this.$router.resolve({
        path: "/coursedetails",
        query: { id: item.id, professionId: item.professionId },
      });
      window.open(rourl.href);
    },
  },
};
</script>
<style lang="scss" scoped>
.evaluating {
  background-color: #f7f7f7;
  .secondary_page_bg {
    overflow: hidden;
    padding-bottom: 46px;
  }
  .warning_wrap {
    margin-top: 50px;
    min-height: 300px;
  }
  .nulu_list {
    padding: 0 30px;
    padding-bottom: 50px;
    background: #fff;
    height: 100%;
    min-height: 300px;
    & > .title {
      font-size: 18px;
      color: #f78919;
      padding: 30px 0;
    }
    .mulu_item {
      padding-right: 66px;
      padding-top: 19px;
      padding-bottom: 19px;
      border-bottom: 1px solid #bfbfbf;
      position: relative;
      .title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 6px;
        .middle {
          flex: 1;
          padding: 0px 5px;
        }
      }
      &:hover {
        color: #f78919;
        cursor: pointer;
      }
      img {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
      &.nulu_active {
        color: #f78919;
      }
    }
  }
  .mulu_details {
    padding: 0 30px;
    background: #fff;
    height: 100%;
    padding-bottom: 50px;
    .title {
      font-size: 18px;
      color: #f78919;
      padding: 30px 0;
    }
    .bangfusub_title {
      margin-bottom: 20px;
      span {
        display: inline-block;
      }
      .middle {
        padding: 0 20px;
      }
    }
    .warning_box {
      margin-bottom: 10px;
      span {
        margin-left: 10px;
        margin-bottom: 10px;
        display: inline-block;
        &:first-of-type {
          margin-left: 0;
        }
        &:nth-of-type(2) {
          margin-left: 0;
        }
      }
    }
    .pingyv {
      margin-bottom: 20px;
    }
  }
  .course_box {
    .hot_course {
      margin-bottom: 20px;
    }
    ::v-deep .course_item .img {
      height: 135px;
    }
  }
}
</style>
